import React from 'react';
import clsx from 'clsx';

const Card = ({ as: Component='div', className, children, interactive=false, ...rest }) => (
  <Component
    className={clsx('bg-white border border-neutral-200 rounded-lgx p-8', interactive && 'hover:shadow-card transition-shadow', className)}
    {...rest}
  >
    {children}
  </Component>
);

export default Card;
